import { createFrontendLogger } from '@template-project/storefront-shared';

export const funnelLogger = createFrontendLogger('storefront-funnel');
